import { Reducer } from 'redux';

import { AppBarTypes, AppBarState } from './types';

const INITIAL_STATE: AppBarState = {
  visible: true,
};

const reducer: Reducer<AppBarState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES APPBAR
    case AppBarTypes.SET_APPBAR_VISIBLE:
      return {
        ...state,
        visible: action.payload.visible,
      };

    default:
      return state;
  }
};

export default reducer;
